import { useState, useEffect } from "react";
import styles from "./FaqBoard.module.css";
import classNames from "classnames/bind";

const cx = classNames.bind(styles);

export default function FaqBoard({ faqData }) {
  const [isOpen, setIsOpen] = useState(null);

  useEffect(() => {
    setIsOpen(null);
  }, [faqData]);

  const handleToggle = (id) => {
    setIsOpen(isOpen === id ? null : id);
  };

  return (
    <div className={cx("faqBoardWrap", "reveal")}>
      {faqData.map((item) => (
        <div
          key={item.id}
          className={cx("faqItemWrap", { active: isOpen === item.id })}
        >
          <button
            id={`faq-btn-${item.id}`}
            className={cx("faqQuestionWrap")}
            onClick={() => handleToggle(item.id)}
            aria-expanded={isOpen === item.id}
            aria-controls={`faq-answer-${item.id}`} // 버튼과 답변 영역을 연결
          >
            <div className={cx("faqQuestionContent")}>
              <span className={cx("qIcon")}>Q.</span>
              <p>{item.question}</p>
            </div>
            <div className={cx("arrowIcon", { up: isOpen === item.id })}>
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <polyline points="6 9 12 15 18 9"></polyline>
              </svg>
            </div>
          </button>

          <div
            id={`faq-answer-${item.id}`}
            className={cx("faqAnswerWrap")}
            role="region"
            aria-labelledby={`faq-btn-${item.id}`}
          >
            <div className={cx("faqAnswerInner")}>
              <div className={cx("faqAnswer")}>
                <span className={cx("aIcon")}>A.</span>
                <p>{item.answer}</p>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
